export default function getResource(label, vars = []) {
    const resources = { newText: 'NEW' };
    return resources[label];
}
